import Axios from 'axios'
// import { getAccessToken } from '@/utils/accessToken'

const commonParam = {
  _ApplicationId: process.env.REACT_APP_ID,
  _ClientVersion: '',
  _InstallationId: '',
}

const service = Axios.create({
  timeout: 30000,
})

/**
 * @description 请求发起前的拦截器
 * @returns {AxiosRequestConfig} config
 */
// service.interceptors.request.use(async (config) => {
//   console.log('config============', config)
//   // if (getAccessToken()) {
//   //     config.headers['token'] = getAccessToken()
//   // }

//   // if (process.env.NODE_ENV === 'development') {
//   //     config.url = `${config.url}`
//   // }
//   return config
// })

const get = (path, params) => {
  let _SessionToken = sessionStorage.getItem('sessionToken')
  return service
    .get(path, { params: { ...commonParam, ...params, _SessionToken } })
    .then((resp) => {
      const data = resp.data
      const { msg } = data
      if (resp.status === 200) {
        if (data.result) {
          return Promise.resolve(data.result)
        } else {
          return Promise.resolve(data)
        }
      } else {
        return Promise.reject(new Error(msg))
      }
    })
    .catch((err) => {
      let __emsg = err.message || ''
      return Promise.reject(new Error(__emsg))
    })
}

const post = (path, data) => {
  let _SessionToken = sessionStorage.getItem('sessionToken')
  return service
    .post(path, { ...commonParam, ...data, _SessionToken })
    .then((resp) => {
      const data = resp.data
      const { msg } = data
      if (resp.status === 200) {
        if (data.result) {
          return Promise.resolve(data.result)
        } else {
          return Promise.resolve(data)
        }
      } else {
        return Promise.reject(new Error(msg))
      }
    })
    .catch((err) => {
      let __emsg = err.message || ''
      return Promise.reject(new Error(__emsg))
    })
}

export default {
  service,
  get,
  post,
}
